import React from 'react';
import { useHistory } from 'react-router-dom';
import Alert from '../../../../components/Alert';
import Button from '../../../../components/Button';

import { PageContainer, ContainerButton } from '../../../../styles/styles';

function SolicitacaoComSucesso() {
    const history = useHistory();

    const successTitle = 'Solicitação enviada com sucesso!';
    const successMessage = [
        'Após análise da sua solicitação o envio será realizado para o endereço cadastrado. Para acessar a carteirinha digital basta acessar o APP Gndi Easy ou, através da área do beneficiário no site ',
        <a href="https://www.gndi.com.br" target="_blank" rel="noreferrer">
            www.gndi.com.br
        </a>,
    ];

    return (
        <PageContainer>
            <Alert type={3} title={successTitle} message={successMessage} />

            <ContainerButton>
                <Button id="backStep" type="primary" onClick={() => history.push('/')}>
                    Acessar home
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default SolicitacaoComSucesso;
